import React from "react"
import PropTypes from "prop-types"
import { Link, useLocation } from "react-router-dom"
import { Row, Col, BreadcrumbItem } from "reactstrap"
import { getMenuInfoByPath } from "../../helpers/menu_helper"

const Breadcrumb = props => {
    const location = useLocation()

    // Get menu info from sideMenu based on current path (exact match only)
    const menuInfo = getMenuInfoByPath(location.pathname)

    // Use menu info if available and props not explicitly provided
    const breadcrumbTitle = menuInfo.breadcrumbTitle || props.title
    const pageHeading = menuInfo.pageHeading || props.breadcrumbItem
    const menuItemName = menuInfo.name || props.breadcrumbItem
    const titleLink = menuInfo.titleLink || props.titleLink || "/dashboard"

    return (
        <Row>
            <Col className="col-12">
                <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                    <div>
                        <h4 className="mb-sm-0 font-size-18">{pageHeading}</h4>
                        {props.secondaryInfo && props.secondaryInfo.length > 0 && (
                            <div className="mt-2">
                                {props.secondaryInfo.map((info, index) => (
                                    info.value && (
                                        <div key={index} className="text-muted" style={{ fontSize: "0.875rem" }}>
                                            {info.value}
                                        </div>
                                    )
                                ))}
                            </div>
                        )}
                    </div>
                    <div className="page-title-right">
                        <ol className="breadcrumb m-0">
                            <BreadcrumbItem>
                                <Link to={titleLink}>{breadcrumbTitle}</Link>
                            </BreadcrumbItem>
                            <BreadcrumbItem active>
                                <Link to="#">{menuItemName}</Link>
                            </BreadcrumbItem>
                        </ol>
                    </div>
                </div>
            </Col>
        </Row>
    )
}

Breadcrumb.propTypes = {
    breadcrumbItem: PropTypes.string,
    title: PropTypes.string,
    titleLink: PropTypes.string,
secondaryInfo: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.string,
    })
  ),
}

export default Breadcrumb
